/**
 * Telegram initData exchange — `POST /api/v1/auth/telegram`.
 *
 * The backend validates the initData HMAC, onboards/fetches the user, and
 * returns a short-lived HS256 JWT. We persist the token to sessionStorage
 * so that closing the tab logs the user out (CLAUDE.md "Authentication").
 */
import type { AuthResponse } from "../lib/types";
import { request, writeJwt } from "./client";

export async function exchangeInitData(initDataRaw: string): Promise<AuthResponse> {
  const response = await request<AuthResponse>("/api/v1/auth/telegram", {
    method: "POST",
    body: { init_data: initDataRaw },
    skipAuth: true,
  });
  writeJwt(response.access_token);
  return response;
}
